import { z } from "zod";
import { payment } from "../validators";

export const serverResponse = z.object({
  page: z.number(),
  perPage: z.number(),
  total: z.number(),
  payments: z.array(payment),
});

export type IPaymentHistory = z.infer<typeof serverResponse>;
